import React from 'react';
import './styles.css';
import { getStore, usePlayerStore, useAppStore } from '../../../../stores/StoreContext';
import FocusHoverControls from './Focus';
import OverviewHoverControls from './Overview';
/**
 * Renders the video controls bar.
 *
 * The controls bar is a container for several controls, including a timeline,
 * play/pause button, timer, annotation options, and annotation labels.
 *
 * @returns {React.ReactElement} The controls bar.
 */
const HoverControls = () => {
  const overlay = usePlayerStore((state) => state.overlay);
  const viewMode = useAppStore((state) => state.viewMode);
  const isLive = usePlayerStore((state) => state.isLive);

  return (
    <>
      {!overlay && (
        <>
          {viewMode !== 'overview' && <FocusHoverControls />}
          {(viewMode === 'overview') && <OverviewHoverControls />}
        </>
      )}
    </>
  );
};

export default HoverControls;
